// extracted by mini-css-extract-plugin
module.exports = {"filterItem":"TranslationsFilters_filterItem__1NBzx","filters":"TranslationsFilters_filters__Anu1L","filterLabel":"TranslationsFilters_filterLabel__1LsyV"};